const BodyAttendance = ({ children, overflowActive = true }) => {
    return (
        <div
            className="main-list__table-wrapper"
            id="listScrollbar"
            data-scrollbar="true"
            tabIndex={"-1"}
            style={{ overflowX: overflowActive ? undefined : "visible" }}
        >
            <div className="scroll-content">
                <table className="main-list__table main-list__table-attendance">{children}</table>
            </div>
        </div>
    );
};

export default BodyAttendance;
